import { CapoPlugin } from "/opt/harpia/harpiawms-web/frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];